import { api } from './api';
import { User, AuthTokens } from '../types';

interface LoginResponse {
  user: User;
  tokens: AuthTokens;
}

interface NewPasswordChallengeResponse {
  challengeName: 'NEW_PASSWORD_REQUIRED';
  session: string;
  email: string;
  message: string;
}

type LoginResult = LoginResponse | NewPasswordChallengeResponse;

interface MeResponse {
  user: User;
}

export const authService = {
  async login(email: string, password: string): Promise<LoginResult> {
    const response = await api.post<LoginResult>('/auth/login', { email, password });
    
    // Check if this is a password change challenge
    if ('challengeName' in response && response.challengeName === 'NEW_PASSWORD_REQUIRED') {
      return response;
    }
    
    // Normal login - store tokens
    const loginResponse = response as LoginResponse;
    localStorage.setItem('accessToken', loginResponse.tokens.accessToken);
    localStorage.setItem('idToken', loginResponse.tokens.idToken);
    localStorage.setItem('refreshToken', loginResponse.tokens.refreshToken);
    
    return loginResponse;
  },

  async completeNewPassword(email: string, newPassword: string, session: string): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/auth/new-password', {
      email,
      newPassword,
      session,
    });
    
    // Store tokens
    localStorage.setItem('accessToken', response.tokens.accessToken);
    localStorage.setItem('idToken', response.tokens.idToken);
    localStorage.setItem('refreshToken', response.tokens.refreshToken);
    
    return response;
  },

  async logout(): Promise<void> {
    try {
      await api.post('/auth/logout', {});
    } finally {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('idToken');
      localStorage.removeItem('refreshToken');
    }
  },

  async getMe(): Promise<User> {
    const response = await api.get<MeResponse>('/auth/me');
    return response.user;
  },

  isAuthenticated(): boolean {
    return !!localStorage.getItem('idToken');
  },
};
